import { dayjs, UK_TIME_ZONE } from "@thalamos/common";
import type { Dayjs } from "@thalamos/common";

/**
 * A browser-local time whose date and time read as UK clocks did at `instant`,
 * for a date picker to show. Outside the UK it is a different instant, so pass
 * it back through `ukInstantOfWallClock` rather than saving it.
 */
export const wallClockOfUkInstant = (instant: Dayjs): Dayjs =>
  dayjs(instant.tz(UK_TIME_ZONE).format("YYYY-MM-DDTHH:mm:ss.SSS"));
